import pkg from '../package.json';
import gitInfo from './git-info.json';

export const APP_VERSION: string = pkg.version;

// Prefer static git-info file; fall back to env or build-time default.
export const BUILD_DATE: string =
  gitInfo.updatedAt ||
  import.meta.env.VITE_BUILD_DATE ||
  new Date().toISOString();

export const GIT_COMMIT: string =
  gitInfo.commit ||
  import.meta.env.VITE_GIT_COMMIT ||
  'unknown';

export const GIT_BRANCH: string =
  gitInfo.branch ||
  import.meta.env.VITE_GIT_BRANCH ||
  'unknown';

